import React from "react";
import ReactSlider from "react-slider";
import styles from "./styles.module.scss";
import useDomainStore from "../../../stores/domain";

function RangeInput({ min, max, step, value, onChange }) {
  const { isKurvDomain } = useDomainStore();
  // Ensure value is an array for range slider
  const rangeValue = Array.isArray(value) ? value : [min, max];

  return (
    <div className={`${styles.rangeContainer} ${isKurvDomain ? styles.kurv_theme : ""}`}>
      <ReactSlider
        className={styles.rangeSlider}
        thumbClassName={styles.rangeThumb}
        trackClassName={styles.rangeTrack}
        min={min}
        max={max}
        step={step}
        value={rangeValue}
        onChange={onChange}
        defaultValue={[min, max]}
      />
    </div>
  );
}

export default RangeInput;
